import React from 'react';

interface CampaignStatusLabelProps {
    status: string;
}

const CampaignStatusLabel: React.FC<CampaignStatusLabelProps> = ({ status }) => {
    const colorMap: Record<string, string> = {
        DRAFT: 'muted',
        IN_PROGRESS: 'info',
        PAUSED: 'default',
        CANCELED: 'secondary',
        COMPLETED: 'success',
    };

    const color = colorMap[status?.toUpperCase()] || 'DEFAULT';
    const label = status?.replace(/_/g, ' ');
    
    return (
        <span className={`label label-${color} label-filled height-100pct`}>
            {label}
        </span>
    );
};

export default CampaignStatusLabel;